'use client';

import React from 'react';

import { useTranslations } from 'next-intl';

import { AcCircularLoader, Overlay } from '@/components/portal-ui';
import { useProcessingAnimationUrl } from '@/state/hooks/useProcessingAnimationUrl';

export const Loader: React.FC = () => {
  const t = useTranslations();
  const animationUrl = useProcessingAnimationUrl();

  return (
    <Overlay overlayPercentage={90} zIndex={1500}>
      <AcCircularLoader text={t('processing')} animationUrl={animationUrl} />
    </Overlay>
  );
};
